import {
  get,
  post,
  blob,
  put,
  getId,
  upload
} from './http'
//登录
export const login = data => post('/ad-user/api/user/login', data) //登录
//流量合作
export const mediaListId = data => post('/ad-ssp/api/mediaList', data) //应用搜索
export const mediaList = data => post('/ad-ssp/api/mediaList', data) //应用列表
export const getMediaDetail = data => post('/ad-ssp/api/mediaListId/' + data) //应用详情查询
export const mediaAdd = data => post('/ad-ssp/api/mediaAdd', data) //添加应用
export const UpMedia = data => post('/ad-ssp/api/mediaEdit', data) //编辑应用
export const slotList = data => post('/ad-ssp/api/slotList', data) //广告位列表
export const slotListIdServes = data => post('/ad-ssp/api/slotListId/' + data) //编辑广告位----新
export const addAd = data => post('/ad-ssp/api/slotAdd', data) //新增广告位
export const SlotShieldingRules = data => post('/ad-ssp/api/addSlotShieldingRules', data) //保存为屏蔽规则
export const slotEditServes = data => post('/ad-ssp/api/slotEdit', data) //编辑广告位
export const mediaData = data => post('/ad-ssp/api/mediaData/' + data) //应用商店下拉列表
export const mediaType = data => post('/ad-ssp/api/mediaDataType', data) //应用类型列表
export const mediaClass = data => post('/ad-ssp/api/mediaDataClasses/' + data) //应用类别列表
export const delAd = data => post('/ad-ssp/api/slotRemove/' + data) //删除广告位
export const slotStatus = data => post('/ad-ssp/api/upDataSlotStatus/' + data.id + '/' + data.slot_status)
//首页&广告数据
export const indexData = data => post('/ad-ssp-index/api/indexList', data) //首页数据
export const monthly = data => post('/ad-ssp-index/api/monthlyIncome', data) //首页前一月数据
export const Year = data => post('/ad-ssp-index/api/ofYearIncome', data) //首页前一年数据
export const getOneData = data => post('/ad-ssp-index/api/indexListA', data) //首页统计图第一列数据
export const blueData = data => post('/ad-ssp-index/api/indexListA', data) //蓝色趋势
export const orangeData = data => post('/ad-ssp-index/api/indexListB', data) //橙色趋势
export const reportForm = data => post('/ad-ssp-index/api/reportDataList', data) //广告数据 数据报表
export const dataCenterdownLoad = data => blob('/ad-admin/api/downLoadTemplate', data)//广告数据下载接口
// export const dataCenterdownLoad = data => blob('/ad-ssp-index/api/downLoad', data)//广告数据下载接口
export const profitSharingDownLoad = data => blob('/ad-ssp-index/api/profitSharingDownLoad', data)//分成收益下载接口
export const fitSharingList = data => post('/ad-ssp-index/api/profitSharingList', data)//分成收益
export const indexSevenDataList = data => post('/ad-ssp-index/api/indexSevenDataList', data)//过去七天数据接口

export const profitSharingAnotherList = data => post('/ad-ssp-index/api/profitSharingAnotherList', data)//分成收益(特殊)
export const profitSharingAnotherDownLoad = data => blob('/ad-ssp-index/api/profitSharingAnotherDownLoad', data)//分成收益下载接口


export const indexAnotherList = data => post('/ad-ssp-index/api/indexAnotherList', data) //首页数据(特殊)
export const comparisonList = data => post('/ad-ssp-index/api/comparisonList', data) //首页环比查询
export const indexAnotherListA = data => post('/ad-ssp-index/api/indexAnotherListA', data) //首页统计图第一列数据(特殊)
export const monthlyAnotherIncome = data => post('/ad-ssp-index/api/monthlyAnotherIncome', data) //首页前一月数据
export const ofYearAnotherIncome = data => post('/ad-ssp-index/api/ofYearAnotherIncome', data) //首页前一年数据


//账户管理
export const selectFin = data => post('/ad-admin/api/selectFinancial/' + data) //财务信息
//export const getUserInfo = data => post('/ad-user/api/user/updataInfo',data)//保存账户信息
export const getUserInfo = data => put('/ad-user/api/user/saveInfo', data)//保存账户信息
export const getAccountInfo = data => getId('/ad-user/api/account/', data)
export const getCity = data => post('/ad-admin/api/cityList', data) //地区三级联动
export const mediaAdoptList = data => post('/ad-ssp/api/mediaAdoptList', data)
export const slotIndexList = data => post('/ad-ssp-index/api/slotIndexList', data)// 广告数据 数据总览
export const slotIndexDataLine = data => post('/ad-ssp-index/api/slotIndexDataLine', data)// 广告数据 数据趋势

export const slotIndexAnotherList = data => post('/ad-ssp-index/api/slotIndexAnotherList', data)// 广告数据 数据总览(特殊)
export const slotIndexAnotherLine = data => post('/ad-ssp-index/api/slotIndexAnotherLine', data)// 广告数据 数据趋势(特殊)
export const reportDataAnotherList = data => post('/ad-ssp-index/api/reportDataAnotherList', data) //广告数据 数据报表(特殊)
export const importSspList = data => post('/ad-admin/api/importSspList', data) //广告数据 数据报表(特殊)
export const anotherDownLoad = data => blob('/ad-admin/api/downLoadTemplate', data)//广告数据下载接口(特殊)
// export const anotherDownLoad = data => blob('/ad-ssp-index/api/anotherDownLoad', data)//广告数据下载接口(特殊)


//export const mediaDataId = data =>post('/ad-ssp/api/mediaDataId',data) //应用平台列表
// const loginTest = data => post('/user/login',data)

//通知中心
export const notificationCenterList = data => post('/ad-ssp/api/notificationCenterList', data) //通知中心列表查询
export const updateNotificationCenter = data => post('/ad-ssp/api/updateNotificationCenter', data) //通知中心修改读取信息

//屏蔽规则
export const shieldingRulesList = data => post('/ad-ssp/api/shieldingRulesList', data) //屏蔽规则列表查询
export const shieldingRulesById = data => post('/ad-ssp/api/shieldingRulesById', data) //屏蔽规则查看详情
export const deleteShielding = data => post('/ad-ssp/api/deleteShielding', data) //屏蔽规则根据id删除
export const RulesMedia = data => post('/ad-ssp/api/shieldingRulesMedia', data) //屏蔽规则应用下拉框
export const RulesSlot = data => post('/ad-ssp/api/shieldingRulesSlot', data) //屏蔽规则广告位下拉框
export const shieldingRulesName = data => post('/ad-ssp/api/shieldingRulesName', data) //屏蔽规则校验接口
export const UploadServe = data => post('/ad-admin/api/adxUpload', data) //COS文件上传
export const addShieldingRules = data => post('/ad-ssp/api/addShieldingRules', data) //屏蔽规则新增
export const updateShieldingRules = data => post('/ad-ssp/api/updateShieldingRules', data) //屏蔽规则编辑
export const shieldingRulesRepeat = data => post('/ad-ssp/api/shieldingRulesRepeat', data) //屏蔽规则编辑

// 数据统计
export const yhcadminReportDataList = data => post('/ad-admin/api/yhcadminReportDataList', data)
export const yhcadminReportNumsData = data => post('/ad-admin/api/yhcadminReportNumsData', data)
export const yhcadminReportTrendChart = data => post('/ad-admin/api/yhcadminReportTrendChart', data)
export const yhcadminReportWd = data => post('/ad-admin/api/yhcadminReportWd', data)
export const generateRandomString = data => post('/ad-ssp/api/generateRandomString', data)
export const ythcadminDataDownLoad = data => blob('/ad-admin/api/ythcadminDataDownLoad', data)




// WEBPACK FOOTER //
// ./src/api/index.js